var React = require('react');

function CurvedArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M104 49C99.5 26 69 -3 25 19","stroke":"black","strokeWidth":"3","strokeLinecap":"round","strokeDasharray":"5 8","key":0}),React.createElement("path",{"d":"M30.4637 25.1431C29.2688 25.0328 20.2788 24.8725 15.9332 24.8061L20.6133 12.1829","stroke":"black","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CurvedArrow.defaultProps = {"width":"150","height":"100","viewBox":"0 0 120 70","fill":"none"};

module.exports = CurvedArrow;

CurvedArrow.default = CurvedArrow;
